import React, { FC, useEffect } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import useTranslation from 'ia-react-core/~/hooks/useTranslation';
import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';

const withHtmlLang = (WrappedComponent: FC) => {
  const WithHtmlLang = (props: {}) => {
    const { language } = useTranslation();

    useEffect(() => {
      document.querySelector('html').setAttribute('lang', language);
    }, [language]);

    return (
      <WrappedComponent
        {...props}
      />
    );
  };

  WithHtmlLang.displayName = getWrappedDisplayName('WithHtmlLang', WrappedComponent);

  return hoistNonReactStatics(WithHtmlLang, WrappedComponent);
};

export default withHtmlLang;
